var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"badge-pendente",attrs:{"pill":"","variant":"warning"}},[_vm._v("Pendente")])}
var staticRenderFns = []

export { render, staticRenderFns }